@for (item of list; track $index) {
  <tpl-sns-logo [name]="item.name" [link]="item.link"></tpl-sns-logo>
}
